<template>
    <div class="modal fade" id="tour_pay_modal" :class="{ in: isShowModal, active: isShow}"
        tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" v-show="isShow">
        <div class="modal-bg"></div>
        <div class="modal-dialog" style="width: 750px;">
            <div class="modal-content">
                <template v-if="bankTransferInfo.popupBoxType===2"> 
                    <div class="warning">
                        <div class="warning-title">
                            重要提醒：
                        </div>
                        <div class="warning-text">
                        您预订的是<span class="em-text">临近航线</span>，为避免因入账延迟而导致订单取消，<span
                            class="em-text">不建议您使用转账方式进行支付。</span>
                        </div>
                        <div class="warning-text">
                        如您仍需转账，<span
                            class="em-text">请于{{bankTransferInfo.showFinalPaymentTime}}前</span>完成转账支付并联系在线客服提供支付水单截图以保留预订，<span
                            class="em-text">超时可能引起您的船票订单被取消，</span>皇家加勒比不承担任何赔偿责任。
                        </div>
                    </div>
                    <div class="popup-split-line"></div>
                </template>
                <div class="modal-header" :class="{bankTransfer:bankTransferInfo.popupBoxType!==2}">银行转账流程</div>
                <div class="modal-body">
                    <p class="content-title">请汇款至以下账户：</p>
                    <p>账户名：皇家加勒比游轮船务（中国）有限公司</p>
                    <p>银行名：摩根大通银行（中国）有限公司上海分行</p>
                    <p>银行地址：中国上海市浦东新区银城中路501号上海中心48楼，200120</p>
<!--                    <p>银行地址：中国上海市静安区南京西路 1601 号越洋国际广场 41 楼, 200040</p>-->
                    <p>（直客）人民币账号：5002032000</p>
                    <div class="offline-pay-flow">
                        <div class="offline-pay-item item-height">
                            <p >支付方式为银行转账/汇款</p>
                        </div>
                        <div class="down-arrow">
                            <img src="https://resource.rcclchina.com.cn/tui2/order/down_arrow_yellow.png">
                        </div>

                        <div class="offline-pay-item item-height">

                            <p >请务必备注好您的订单号、姓名</p>
                        </div>
                        <div class="down-arrow">
                            <img src="https://resource.rcclchina.com.cn/tui2/order/down_arrow_yellow.png">
                        </div>

                        <div class="offline-pay-item item-height">
                            <p>银行转账/汇款成功并与客服确认</p>
                            <p>请务必在完成付款后致电400-820-7195与客服确认</p>
                        </div>
                    </div>
                    <div class="reminder">特别提醒：
                        <p>1.若您预订的房型为特定主题房（如巧虎主题房），请您通过线上渠道进行订单支付。线下转账需人工入账且时间较长，会导致您的订单没有及时入账而被系统自动取消。
                            <br>2.转账完成后需至少3个工作日进行入账，未完成入账前您无法办理在线值船。
                            <br>3.若公司转账，退款时需提供所需的公司证明及多份英文材料，退款周期较长，敬请谅解。
                        </p>
                    </div>
                    <div class="btn-confirm" @click="onModalClose">我已阅读并知晓</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "BankPopup",
    props: {
        isShow: {
            type: Boolean
        },
        bankTransferInfo: {
            type: Object,
            default () {
                return {}
            }
        }

    },
    data () {
        return {
            isShowModal: false
        }
    },
    methods: {

        onModalClose () {
            this.isShowModal = false
            setTimeout(()=> {
                this.$emit('onModalClose')
            }, 100)
        }
    },
    watch: {
        isShow (newValue) {
            setTimeout(()=> {
                this.isShowModal = newValue
            }, 100)
        }
    }
}
</script>

<style lang="less" scoped>

.modal.active {
    display: flex;
    justify-content: center;
    align-items: center;
}
.modal-dialog{
    top: 0;
}

.modal-bg {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
}
    .warning{
        padding: 15px 30px 17px ;
        .warning-title{
            font-size: 20px;
            color: #FF0000;
            line-height: 48px;
            font-weight: bold;
        }
        .warning-text{
            font-size: 13px;
            color: #060606;
            font-weight: bold;
        }
        .em-text {
            color: #FF0000;
        }
    }
    .popup-split-line{      
            height: 2px;
            background: #F3F3F3;
            margin: 0 30px;
    }
 .modal-header {
    border: 0;
    margin-left: 30px;
    font-size: 20px;
    color: #282b2c;
    font-weight: bold;
    padding: 0;
    padding-top: 15px;
    &.bankTransfer{
        padding-top: 30px;
    }
}
.modal-body {
    max-height: 60vh;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 15px 30px 30px 30px;
    font-size: 13px;
    color: #282b2c;
    p.content-title {
        font-size: 15px;
    }
    .offline-pay-flow {
        text-align: center;
        color: white;
        margin-top: 15px;
        .offline-pay-item {
            background: #54a3de;
            font-size: 12px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            line-height: 16px;
            p {
                margin-bottom: 0px;
            }
        }
        .item-height {
            height: 50px;
        }

    }
    .down-arrow {
        margin: 10px auto;
    }
    .reminder{
        font-size: 13px;
        margin-top: 22px;
        margin-bottom: 17px;
        color: #1F2122;
    }
    .btn-confirm{
        width: 209px;
        height: 37px;
        background: linear-gradient(180deg, #FBD133 0%, #F7BD33 100%);
        border-radius: 3px;
        font-size: 14px;
        color: #060606;
        line-height: 37px;
        text-align: center;
        margin: 0 auto;
        font-weight: bold;
    }
}
</style>
